// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__2DRiG"};